export default (key) => {
    const $metaElement = document.querySelector(`meta[itemprop="${key}"]`);

    if ($metaElement) {
        return $metaElement.content;
    }
};
